import React from "react";
import { useLocation } from "react-router-dom";
import { PageTitle } from "../atoms/PageTitle";
import { getPageTitle } from "../../core/pageTitles";
import { useCustomPageTitle } from "../../core/PageTitleContext";

function normalizeTitle(s) {
  return String(s ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

/**
 * Same styling as PageTitle, but does not render when the text equals the V2
 * layout header (next to the back arrow), including when a page sets a custom
 * header via `usePageTitle`.
 *
 * Only applies to plain string or number children. Composite children (JSX)
 * always render so subtitles / compound headings stay visible.
 */
export function PageBodyTitle({ children, ...rest }) {
  const { pathname } = useLocation();
  const customTitle = useCustomPageTitle();
  const headerTitle = customTitle ?? getPageTitle(pathname);

  if (typeof children === "string" || typeof children === "number") {
    const bodyText = String(children).trim();
    if (bodyText && normalizeTitle(bodyText) === normalizeTitle(headerTitle)) {
      return null;
    }
  }

  return <PageTitle {...rest}>{children}</PageTitle>;
}
